enum DIRECTORY_TYPE {
    GOOGLE = 'google',
}

const TRANSLATION_NAMESPACE = 'translation';

const MIN_WIDTH_DESKTOP = 1024;

export { DIRECTORY_TYPE, TRANSLATION_NAMESPACE, MIN_WIDTH_DESKTOP };
